import { render, staticRenderFns } from "./deanHeaderLogo.vue?vue&type=template&id=19aec7c1&scoped=true"
import script from "./deanHeaderLogo.vue?vue&type=script&lang=ts"
export * from "./deanHeaderLogo.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderLogo.vue?vue&type=style&index=0&id=19aec7c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aec7c1",
  null
  
)

export default component.exports